import "../css/Home.css";

const Home = () => {
  return (
    <main className="salon-home">

      {/* 1. HERO */}
      <section className="home-hero">
        <div className="hero-text">
          <h1>
            Beauty,<br />
            refined.
          </h1>
          <p>
            A luxury salon experience crafted with intention,
            calm, and timeless elegance.
          </p>
        </div>
        <div className="hero-image" />
      </section>

      {/* 2. INTRO */}
      <section className="home-intro">
        <p>
          More than a salon —<br />
          a space for self-care.
        </p>
      </section>

      {/* 3. EDITORIAL DIVIDER */}
      <section className="home-divider">
        <span>EST. ÉLAN</span>
      </section>

      {/* 4. PHILOSOPHY */}
      <section className="home-philosophy">
        <div className="philosophy-text">
          <h2>Our Philosophy</h2>
          <p>
            At Élan, beauty is never rushed.
            Every service is designed to feel
            personal, calm, and considered.
          </p>
        </div>
        <div className="philosophy-image" />
      </section>

      {/* 5. FOUNDER */}
      <section className="home-founder">
        <div className="founder-image" />
        <div className="founder-text">
          <h2>Led by Vision</h2>
          <p>
            Founded by stylists who believe
            beauty should feel effortless,
            intentional, and deeply personal.
          </p>
        </div>
      </section>

      {/* 6. SERVICES */}
      <section className="home-services">
        <h2>Signature Services</h2>
        <div className="services-grid">
          <div>
            <h3>Hair</h3>
            <p>Precision cuts & bespoke color</p>
          </div>
          <div>
            <h3>Skin</h3>
            <p>Advanced facial treatments</p>
          </div>
          <div>
            <h3>Nails</h3>
            <p>Minimal, refined care</p>
          </div>
          <div>
            <h3>Bridal</h3>
            <p>Tailored beauty experiences</p>
          </div>
        </div>
      </section>

      {/* 7. FULL IMAGE */}
      <section className="home-full-image" />

      {/* 8. PROCESS */}
      <section className="home-process">
        <div>
          <span>01</span>
          <p>Consultation & listening</p>
        </div>
        <div>
          <span>02</span>
          <p>Personalized approach</p>
        </div>
        <div>
          <span>03</span>
          <p>Refined execution</p>
        </div>
      </section>

      {/* 9. EXPERIENCE */}
      <section className="home-experience">
        <div>
          <span>Atmosphere</span>
          <p>Quiet, light-filled interiors</p>
        </div>
        <div>
          <span>Products</span>
          <p>Premium, skin-first formulas</p>
        </div>
        <div>
          <span>Approach</span>
          <p>Personal & unhurried</p>
        </div>
      </section>

      {/* 10. QUOTE */}
      <section className="home-quote">
        <p>
          Beauty feels different<br />
          when time slows down.
        </p>
      </section>

      {/* 11. TESTIMONIAL */}
      <section className="home-testimonial">
        <p>
          “Élan is the first salon where
          I truly felt listened to.”
        </p>
        <span>— Client Review</span>
      </section>

      {/* 12. GALLERY STRIP */}
      <section className="home-gallery">
        <div className="gallery-img img1" />
        <div className="gallery-img img2" />
        <div className="gallery-img img3" />
      </section>

      {/* 13. CLOSING */}
      <section className="home-closing">
        <h2>Welcome to Élan</h2>
        <p>
          A salon designed for balance,
          beauty, and calm confidence.
        </p>
      </section>

    </main>
  );
};

export default Home;
